exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".la-menu-enter-active, .la-menu-leave-active {\n  -webkit-transition: opacity 0.5s;\n  transition: opacity 0.5s;\n}\n.la-menu-enter, .la-menu-leave-to {\n  opacity: 0;\n}", ""]);

// exports
